// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Qd8rr","content":"styles_content__xlDQ1","selectAll":"styles_selectAll__1u1Ft"};